export const HELP = 'help';
export const DEFAULT = 'default';
export const ERROR = 'error';